import React from 'react';
import PivotTableUIWrapper from './PivotTableUIWrapper';

export default class App extends React.Component {
    componentWillMount() {
        this.setState({
            pivotState: {
                data: this.props.data,
                rows: this.props.default.rows,
                cols: this.props.default.cols,
                hiddenFromDragDrop: this.props.hide
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        let currentPivotState = {...this.state.pivotState};
        currentPivotState.data = nextProps.data;
        this.setState({pivotState: currentPivotState});
    }

    render() {
        return (
            <div>
                <div className="row text-center">
                    <PivotTableUIWrapper {...this.state.pivotState} onDataSelect={this.props.onDataSelect}/>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/pivottable/Wrapper.js